import { render } from "./VideoPicker.vue?vue&type=template&id=ad67d8d6&scoped=true"
import script from "./VideoPicker.vue?vue&type=script&lang=ts"
export * from "./VideoPicker.vue?vue&type=script&lang=ts"

import "./VideoPicker.vue?vue&type=style&index=0&id=ad67d8d6&scoped=true&lang=css"
import "../../components/Video/VideoStyling.css?vue&type=style&index=1&lang=css"
script.render = render
script.__scopeId = "data-v-ad67d8d6"

export default script